<template>
  <v-app-bar
    app
    height="60"
    color="app-colors-background"
    :class="[elevation, { isMobileHeader: isMobile }]"
    class="application-bar"
  >
    <div
      class="menu-navigation d-flex align-center flex-grow-1 flex-shrink-1 mr-4"
    >
      <router-link
        color="white"
        class="text-decoration-none font-weight-bold d-flex align-center root-link pr-3"
        :to="{ name: 'page', params: { urlKey: 'home' } }"
      >
        <logo v-if="language === 'uk'" class="mr-1" />
        <logo-eng v-else-if="language !== 'uk'" class="mr-1" />
      </router-link>
      <locale-changer-toolbar class="d-md-flex"></locale-changer-toolbar>
      <search-toolbar />
      <v-spacer></v-spacer>
      <div class="d-flex align-center headerBtns">
        <v-btn
          class="order-agreement-button"
          dark
          depressed
          :to="{ name: 'page', params: { urlKey: 'requestDraftAgreementForm' } }"
        >
          {{$t('header.RequestDraftAgreement')}}
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center headerBtns" v-if="!isMobile">
        <v-btn
          class="text-decoration-none askod-online-link"
          dark
          depressed
          href="https://askod.online"
          target="_blank"
        >
          {{$t('header.askodOnline')}}
        </v-btn>
        <router-link
          class="text-decoration-none "
          :to="{ name: 'subDynamic', params: item.param }"
          :key="index"
          v-for="(item, index) in navigations"
          >{{ item.name }}</router-link
        >
      </div>

      <v-app-bar-nav-icon
        id="open-menu-button"
        class="ml-6"
        @click="$emit('input', !value)"
      >
        <div class="burger-to-cross" :class="{ 'is-active': value }">
          <div class="burger-icon"></div>
        </div>
      </v-app-bar-nav-icon>
    </div>
  </v-app-bar>
</template>
<script>
import Logo from '../_shared/svg/Logo.vue'
import LogoEng from '../_shared/svg/LogoEng.vue'
import SearchToolbar from './SearchToolbar.vue'
import localeChangerToolbar from './localeChangerToolbar.vue'
import Cookie from 'vue-cookie'
export default {
  components: { Logo, LogoEng, SearchToolbar, localeChangerToolbar },
  name: 'Header',
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  methods: {
    clickBurdger() {}
  },
  computed: {
    navigations: function() {
      return [
        { name: this.$t('header.products'), param: { urlKey: 'askod', subUrlKey: 'products' } },
        {
          name: this.$t('header.services'),
          param: { urlKey: 'ourcompany', subUrlKey: 'services' }
        },
        {
          name: this.$t('header.contacts'),
          param: { urlKey: 'ourcompany', subUrlKey: 'contact' }
        }
      ]
    },
    elevation: function () {
      return this.value ? 'elevation-2' : 'elevation-0'
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile
    },
    language: function () {
      const loc = Cookie.get('locale')
      return !loc ? 'uk' : loc
    }
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
@import '~sass-burger/_burger.scss';
.askod-online-link {
  text-transform: none;
  letter-spacing: normal;
}
.order-agreement-button {
  text-transform: none;
  letter-spacing: normal;
  font-size: 18px !important;
}
.application-bar {
  &.isMobileHeader {
    .v-toolbar__content {
      flex-direction: row-reverse;
    }
  }

  .v-toolbar__content {
    padding-left: 12rem;
    padding-right: 12rem;
  }
}

.v-application {
  .menu-navigation {
    a {
      font-size: 1.75rem;
      color: white;

      &:not(.root-link) {
        margin-left: 2.4rem;
      }
    }
    a.root-link {
      margin-right: 0.8rem;
    }
    a span {
      font-size: 2rem;
    }
  }
}

.menu-items {
  margin-top: 1.5rem;
  padding-left: 1.7rem;
  font-size: 1.6rem;
  border-left: 2px solid #5f5f5f;
  a:not(:first-child) {
    margin-top: 1rem;
  }
}
.menu-container {
  position: relative;
  overflow: hidden;

  svg {
    position: absolute;
  }
  .svg-circle {
    right: 14.3rem;
    bottom: 10rem;
  }
  .svg-elipse {
    right: 0;
    bottom: 0;
  }
  .svg-circle-2 {
    right: 11rem;
    bottom: 25rem;
  }
}

.header-button {
  text-transform: none !important;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .application-bar.v-app-bar.v-app-bar--fixed {
    z-index: 7;
  }
  .application-bar .v-toolbar__content {
    padding-left: $xs-indent;
    padding-right: $xs-indent;
  }

  .v-application {
    .menu-navigation {
      a,
      a span {
        font-size: 1.4rem;
      }
    }
  }
}

.burger-to-cross {
  display: inline-block;
  padding: 0.5em;
}

.burger-icon {
  @include burger(25px, 3px, 5px, #fcfcfc);
}

.burger-to-cross.is-active .burger-icon {
  @include burger-to-cross;
}

.headerBtns {
   color: white;

  a:hover {
    color: #8ac5ff;
  }
}
</style>
